import { AfterViewChecked, Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { MessageService } from 'primeng/components/common/messageservice';
import { ConfirmationService } from 'primeng/primeng';

import { WebPage } from '../../shared/web-page';
import { Perfis } from '../../../models/perfis';
import { Usuario } from '../../../models/usuario';

import { AuthService } from '../../admin/auth.service';
import { UnidadeService } from '../../shared/services/unidade.service';
import { EmpresaService } from '../../../services/empresa.service';
import { Empresa } from '../../../models/empresa.model';
import { Vaga, VagaCategoria, VagaUnidade } from '../../../models/vaga.model';
import { Util } from '../../shared/util';
import { DOCUMENT } from '@angular/common';

@Component({
    selector: 'analisar-proposta',
    templateUrl: 'analisar-proposta.component.html'
})

export class AnalisarPropostaComponent extends WebPage implements OnInit, AfterViewChecked {
    public titulo = "Analisar"
    public usuario: Usuario;
    public perfis: any;
    public unidades: any;
    public formAnalisarProposta: FormGroup;
    public formUnidade: FormGroup;
    public idEmpresa: string;
    public empresa: Empresa;
    public display = false;
    public isEdicaoUnidade = false;
    //Vaga Por Unidade
    public vagaSelecionada: Vaga;
    public unidadeSelecionada: string;
    
    listaStatus = [
        //{descricao: 'Aguadando análise', idStatus: '5E7478ED-D7E7-4746-8142-7C6DF0249080'},
        {descricao: 'Aprovado', idStatus: '32BAB650-B896-4733-AFBA-7A6FD8119339'},
        {descricao: 'Reprovado', idStatus: '5D4204C1-05A7-4F01-B04A-6C52EC42872F'},
        {descricao: 'Aprovado Parcialmente', idStatus: '8F9B683D-E01C-4811-9A67-265E5EE1A250'},
    ]
    listaUfs = Util.getAllUfs();
    listaCidades = [
        {label: 'Acre', value: '1'},
        {label: 'Ceará', value: '2'},
        {label: 'Bahia', value: '3'},
        {label: 'São Paulo', value: '4'},
        {label: 'Rio de Janeiro', value: '5'},
    ]
    listaVagas : Vaga[] = []
    listaVagasUnidades : VagaUnidade[] = []
    public nroVagasb = 0;
    public messageErro = '';
    
    public empresaIn: Empresa;
    public totalVagasEmpresa = 0;
    public totalVagasUnidade = 0;
    public totalVagasDisponiveis: number = 0;
    public totalVagasDisponiveisPorCidade: number = 0;
    
    constructor(@Inject(DOCUMENT) private document: Document,private authService: AuthService,
        private unidadeService: UnidadeService,
        private empresaService: EmpresaService,
        private fb: FormBuilder,
        messageService: MessageService,
        private confirmationService: ConfirmationService,
        private router : Router,
        private route: ActivatedRoute) {
            super(messageService);

        this.usuario = this.authService.informacoesUsuario();
        this.perfis = Perfis;
    
        this.formAnalisarProposta = fb.group({
            cnpj: [null],
            razaoSocial: [null],
            totalVagas: [null],
            justificativa: [null],
            idStatus: ['',[Validators.required]],
            totalVagasDisponivel: [null],
        });
        this.formUnidade = fb.group({
            idUnidade: [null],
        });
        this.route.paramMap.subscribe(params => {
            this.idEmpresa = params.get('idEmpresa');
        });      
    }
    
    ngAfterViewChecked(): void {
        //throw new Error('Method not implemented.');
    }

    ngOnInit() { 
        if (
            this.usuario.Perfil === Perfis.AdministradorSistema
            || this.usuario.Perfil === Perfis.GestorDex
            || this.usuario.Perfil === Perfis.AdministrativoDex
            ) {
                this.isLoading = true;
                //alert(JSON.stringify(this.usuario));
            }
            this.isLoading = false;
            this.carregarUnidades();
            this.carregarDadosEmpresa();   
            this.totalVagasDisponiveis = (this.totalVagasEmpresa - this.totalVagasUnidade);         
    }
    carregarUnidades() {
        this.isLoading = true;
        this.unidadeService.getUnidades()
        .finally(() => this.isLoading = false)
        .subscribe(
            unidades => this.unidades = unidades,
            error => this.gerenciaErro(error)
        );
    }

    carregarDadosEmpresa(){
        if(this.idEmpresa){
            this.titulo = "Editar Análise"
            this.isLoading = true;
            this.empresaService.getEmpresaById(this.idEmpresa)
            .finally( () => {
                this.isLoading = false;
            })
            .subscribe(
                data => {
                    this.empresa = data;
                    let idStatusAnalise;
                    if(data.idStatusAnalise.toUpperCase() == '5E7478ED-D7E7-4746-8142-7C6DF0249080'){
                        this.titulo = 'Analisar Vagas';
                    } else{
                        idStatusAnalise = data.idStatusAnalise.toUpperCase();
                    }
                    console.log('Empresa>>' + JSON.stringify(data.vagas));
                    
                    this.formAnalisarProposta.patchValue({
                        cnpj: data.cnpj,
                        razaoSocial: data.razaoSocial,
                        idStatus: idStatusAnalise,
                        justificativa: data.justificativa,
                    })
                    this.listaVagas = data.vagas;
                    data.vagas.forEach(
                        (vaga) => {
                            this.totalVagasEmpresa += vaga.numeroVagas;
                            vaga.vagaUnidades.forEach(
                                (vagaUnidade) => {
                                    vagaUnidade.unidade = this.unidadeService.getUnidadeFull(vagaUnidade.idUnidade).subscribe((u)=>{
                                        vagaUnidade.unidade = u;
                                        this.listaVagasUnidades.push(vagaUnidade);
                                        this.totalVagasUnidade += vagaUnidade.numeroVagas;
                                });
                            });                            
                        });
                    
                }
            )
        }
    }
    getCategorias(value:VagaCategoria[]){
        return value.map((item) => {
            return  ' ' + item.categoria.descricao.substring(10,11);
        });
    }
    onSubmit(){
        if(this.formAnalisarProposta.invalid) return;
        this.empresaIn = this.empresa;
        this.empresaIn.vagas = [];
        this.empresaIn.vagas.push(... this.listaVagas);
        this.empresaIn.vagas.forEach((v) => {
            v.vagaUnidades = [];
            this.listaVagasUnidades.filter( (f) => {
                if(v.idVaga == f.idVaga){
                    v.vagaUnidades.push(f);
                }
            })
        });
        this.empresaIn.idStatusAnalise = this.formAnalisarProposta.controls.idStatus.value;
        try{
            this.empresaIn.justificativa = this.formAnalisarProposta.controls.justificativa.value.trim();
        }catch{}
        console.log(this.empresaIn);
        this.empresaService.updateEmpresa(this.empresaIn, this.usuario.Nome).subscribe(
            (data) => {
                if(data){
                    this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: 'Proposta Salva com Sucesso!' });
                    this.router.navigate(['/gerenciar-vagas']);
                }
            },
            error => {
                console.log(error);
            }
        );
    }
    
    voltar(){
        this.router.navigate(['/gerenciar-vagas']);
    }
    getUfNome(valor){
        if(valor){
            return this.listaUfs.filter((u)=>{
                return  u.value == valor
            })[0].label
        }
        return '';
    }
    //Vaga Por Unidade
    abrirVagaUnidade(item){
        this.isEdicaoUnidade = false;
        this.isLoading = true;
        this.vagaSelecionada = item;
        this.totalVagasDisponiveisPorCidade = 0;
        this.vagaSelecionada = this.listaVagas.filter( v => v.uf == item.uf && v.cidade == item.cidade)[0];
        var totalCidade:number = 0;
        this.listaVagasUnidades.forEach(
            (item, index) => {
                if(item.uf == item.uf && item.cidade == item.cidade){
                    totalCidade += +item.numeroVagas;
                }
            }
        )
        this.totalVagasDisponiveisPorCidade = (this.vagaSelecionada.numeroVagas - totalCidade);
        this.unidadeService.getUnidadesByIdUfSigla(item.uf)
        .finally(() => this.isLoading = false)
        .subscribe(
            unidades => {
                this.unidades = unidades
                this.display = true;
                this.isEdicaoUnidade = false;
                this.formUnidade.controls.idUnidade.enable();
            },
            error => this.gerenciaErro(error)
        );
        
    }
    adicionarVagaUnidade(unidade, numeroVagas){
        console.log(this.unidadeSelecionada);
        this.messageErro = '';
        this.totalVagasUnidade = 0;
        if(numeroVagas){
            if(+numeroVagas.value <= 0) return;
            var totalCidade = +this.vagaSelecionada.numeroVagas;
            var totalUnidade = +numeroVagas.value;
            var totalOcupada = 0;
            var isExistente = false;
            this.listaVagasUnidades.forEach(
                (item, index) => {
                    if(item.uf == this.vagaSelecionada.uf && item.cidade == this.vagaSelecionada.cidade){
                        totalUnidade += +item.numeroVagas;
                        totalOcupada += +item.numeroVagas;
                    }
                    this.totalVagasUnidade += +item.numeroVagas;
                }
            )
            var vagaS = this.vagaSelecionada;
            this.listaVagasUnidades.forEach(
                (item, index) => {
                    isExistente = (item.uf == vagaS.uf 
                        && item.cidade == vagaS.cidade 
                        && item.idUnidade ==  unidade.value)
                        if(vagaS){}
                }
            )
            if(this.isEdicaoUnidade){
                try{
                    var vagaAtualUnidade = 0;
                    this.listaVagasUnidades.map(u => 
                            {
                            if(u.idUnidade == unidade.value){
                               vagaAtualUnidade += +numeroVagas.value;                       
                            }else{
                               vagaAtualUnidade += +u.numeroVagas;
                            };
                        }
                    );
                    if(vagaAtualUnidade > totalCidade){
                        this.messageErro = 'Total de Vagas excedido!';
                        this.nroVagasb = this.vagaSelecionada.numeroVagas - totalOcupada;
                        return;//alert();
                    }
                    this.totalVagasUnidade = 0;
                    this.listaVagasUnidades.map(u => 
                            {
                            if(u.idUnidade == unidade.value){
                                u.numeroVagas = +numeroVagas.value;                       
                            };
                        }
                    );
                    this.listaVagasUnidades.map(u => { this.totalVagasUnidade += +u.numeroVagas; });
                    console.log(vagaAtualUnidade);
                    console.log(this.totalVagasUnidade);
                    console.log(this.totalVagasEmpresa);
                    this.totalVagasDisponiveis = this.totalVagasEmpresa - this.totalVagasUnidade;
                    this.formAnalisarProposta.patchValue({
                        totalVagasDisponivel: this.totalVagasDisponiveis
                    })
                    this.document.getElementById('closeModalUnidade').click();
                    this.display = false;
                    this.isEdicaoUnidade = false;
                    this.messageService.add({
                        severity: 'success',
                        summary: 'SUCESSO',
                        detail: 'Vaga editada com sucesso!',
                    });
                }catch{}
                this.listaVagasUnidades.forEach(
                    (item, index) => {
                        this.totalVagasUnidade += +item.numeroVagas;
                    }
                )
                return;
            }else if(isExistente){
                this.messageErro = 'Os dados informados já possuem vaga definida!'
                return;// alert();
            }
            if(totalUnidade > totalCidade){
                this.messageErro = 'Total de Vagas excedido!';
                this.nroVagasb = this.vagaSelecionada.numeroVagas - totalOcupada;
                return;//alert();
            }
            this.totalVagasDisponiveis = this.totalVagasEmpresa - this.totalVagasUnidade;
            this.unidadeService.getUnidadeFull(unidade.value)
            .finally(() => this.isLoading = false)
            .subscribe(
                (data) => {
                    var vagaSelecao = {
                        idVaga: this.vagaSelecionada.idVaga,
                        idUnidade: data.idUnidade,
                        nomeUnidade: data.nomeUnidade,
                        unidade: data,
                        uf: this.vagaSelecionada.uf,
                        cidade: this.vagaSelecionada.cidade,
                        numeroVagas: numeroVagas.value,
                        vagaCategorias: this.vagaSelecionada.vagaCategorias,
                        ativo: true,
                    }
                    this.listaVagasUnidades.push(vagaSelecao)
                    if(this.isEdicaoUnidade) this.display = false;
                    this.messageService.add({
                        severity: 'success',
                        summary: 'SUCESSO',
                        detail: 'Vaga adicionada com sucesso!'
                    });
                    this.document.getElementById('closeModalUnidade').click();
                },
                error => this.gerenciaErro(error)
            );
        }
    }
    limparDadosModal(){
        this.messageErro = '';
        this.display = false;
        this.isEdicaoUnidade = false;
    }
    getUnidadeNome(value){
        let cidadeNome = '';
        console.log(
        );
    }
    editarUnidade(valor){
        this.totalVagasDisponiveisPorCidade = 0;
        let vagaUnidade:VagaUnidade = this.listaVagasUnidades.filter(item => item.idUnidade == valor)[0];
        this.vagaSelecionada = this.listaVagas.filter( v => v.uf == vagaUnidade.uf && v.cidade == vagaUnidade.cidade)[0];
        var totalCidade:number = 0;
        this.listaVagasUnidades.forEach(
            (item, index) => {
                if(item.uf == vagaUnidade.uf && item.cidade == vagaUnidade.cidade){
                    totalCidade += +item.numeroVagas;
                }
            }
        )
        this.totalVagasDisponiveisPorCidade = (this.vagaSelecionada.numeroVagas - totalCidade);
        this.unidadeService.getUnidadesByIdUfSigla(vagaUnidade.uf)
        .finally(() => this.isLoading = false)
        .subscribe(
            unidades => {
                this.unidades = unidades
                this.display = true;
                this.isEdicaoUnidade = true;
                this.vagaSelecionada = this.listaVagas.filter( v => v.idVaga == vagaUnidade.idVaga)[0];
                this.formUnidade.patchValue(
                    {
                        idUnidade:vagaUnidade.idUnidade,
                    }
                );
                this.formUnidade.controls.idUnidade.disable();
                this.nroVagasb = vagaUnidade.numeroVagas;
            },
            error => this.gerenciaErro(error)
        );
        
    }
    removerUnidade(valor){
        this.listaVagasUnidades = this.listaVagasUnidades.filter(item => item !== valor);
    }
    onPermitirEditar(value){
        let isDesativar = false;
         this.listaVagasUnidades.forEach(
                (item, index) => {
                    if(item.idVaga == value){
                        isDesativar = true;
                    }
                }
            )
        return isDesativar;
    }
    onEditarVaga(event,value){
        return;
        // let vaga = event.target.value;
        // let abortar = false;
        // this.listaVagasUnidades.forEach(
        //         (item, index) => {
        //             if(item.uf == value.uf && item.cidade == value.cidade){
        //                 abortar = true;
        //             }
        //         }
        //     )
        // if(abortar) return;
        // this.listaVagas.forEach(
        //     (item, index) => {
        //         if(item.idVaga == value.idVaga){
        //                 this.listaVagas[index].numeroVagas = vaga;                      
        //             //this.editarVaga(value);
        //         }
        //     }
        // )
    }
    editarVaga(value){
        return;
        // this.sleep(1000);
        // this.listaVagas.forEach(
        //     (item, index) => {
        //         if(item.idVaga == value.idVaga){
        //             this.listaVagas[index].isEditar = !this.listaVagas[index].isEditar;
        //         }
        //     }
        // )
    }

    sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
    
    // Exemplo de uso:
    async  aguarde() {
        console.log("Antes de dormir");
        await this.sleep(2000); // Pausa por 2000 milissegundos (2 segundos)
        console.log("Depois de dormir");
    }
}


// WEBPACK FOOTER //
// ./src/app/components/vaga/analisar-proposta/analisar-proposta.component.ts